import './OkulyonetimSearchFilter.scss';

import { Checkbox } from 'antd';
import React from 'react';

interface OkulyonetimSearchFilterProps {
    searchValue: string;
}

const OkulyonetimSearchFilter: React.FC<OkulyonetimSearchFilterProps> = ({ searchValue }) => {
    return (
        <div className="okulyonetim-search-filter">
            <div className="search-title">Arama</div>
            <div className="search-checkbox">
                <Checkbox defaultChecked  />
                <span>{searchValue}</span>
            </div>
        </div>
    );
};

export default OkulyonetimSearchFilter;
